import PegasusPlaceFinder from "@PegasusCore/pegasus-one-place-finder/src/script.js";

export class MyPlaceFinder extends PegasusPlaceFinder {
    constructor(options) {
        super(options);
    }
    // Do your custom code.
}
document.addEventListener("alpine:init", () => {
    Alpine.data('PegasusPlaceFinder', (options) => {return new MyPlaceFinder(options)});
});

